/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col } from "@neumetric/blueprint-lib/components";
import {
  getSessionStatus,
  commonAction,
  getDepartments,
  getCurrentUser,
} from "@neumetric/blueprint-lib/store";

export const AuditorHomeScreen = (props) => {
  const initialized = React.useRef(false);
  const dispatch = useDispatch();
  const sessionStatus = useSelector(getSessionStatus);
  const departments = useSelector(getDepartments);

  const isListLoaded = Array.isArray(departments);
  const user = useSelector(getCurrentUser);
  React.useEffect(() => {
    if (sessionStatus === "LOGGED_IN" && !initialized.current) {
      initialized.current = true;
      dispatch(commonAction.fetchDepartments());
      dispatch(commonAction.fetchPriorities());
      dispatch(commonAction.fetchActiveUsers({ orgId: user.org.id }));
    }
  }, [sessionStatus]);

  return (
    <React.Fragment>
      {isListLoaded && (
        <Col className="w-100 h-100 overflow-hide pt-0">{props.children}</Col>
      )}
    </React.Fragment>
  );
};
